<template>
    <table-ish>
        <table-ish-row
            v-for="job_sheet in job_sheets"
            :key="job_sheet.uuid"
        >
            <table-ish-cell-router-link
                :to="{
                    name: $router.fix('job-sheets.show'),
                    params: {
                        job_sheet: job_sheet.uuid
                    }
                }"
            >
                <slot
                    name="primary"
                    :job_sheet="job_sheet"
                >
                    <with-variables
                        :variables="{
                            contact: _.get(job_sheet, 'contacts.data[0]')
                        }"
                        v-slot="{ contact }"
                    >
                        <truncate-hack>
                            {{ contact.name }}
                        </truncate-hack>
                    </with-variables>
                </slot>

                <template slot="secondary">
                    <slot
                        name="secondary"
                        :job_sheet="job_sheet"
                    />
                </template>
            </table-ish-cell-router-link>

            <table-ish-cell :shrink="true">
                <div class="w-6 h-6">
                    <base-dropdown
                        placement="bottom-end"
                        class="w-full h-full"
                    >
                        <button
                            slot="trigger"
                            slot-scope="{ is_open, toggle }"
                            :class="{ 'shadow-outline': is_open }"
                            class="w-full h-full btn btn-none"
                            type="button"
                            @click.prevent="toggle"
                        >
                            <base-svg
                                name="icon-dots-horizontal"
                                class="w-full h-full"
                            />
                        </button>

                        <div
                            slot="menu"
                            class="w-64 dropdown-menu"
                        >
                            <router-link
                                :to="{
                                    name: $router.fix('job-sheets.show'),
                                    params: {
                                        job_sheet: job_sheet.uuid
                                    }
                                }"
                                class="dropdown-menu-link"
                            >
                                View
                            </router-link>

                            <button
                                class="dropdown-menu-link"
                            >
                                Delete
                            </button>
                        </div>
                    </base-dropdown>
                </div>
            </table-ish-cell>
        </table-ish-row>
    </table-ish>
</template>

<script>
    import StateCssMixin from '../mixins/state-css'

    export default {
        mixins: [
            StateCssMixin
        ],
        props: {
            jobSheets: {
                type: Array,
                required: true
            }
        },
        computed: {
            job_sheets () {
                return this.jobSheets
            }
        }
    }
</script>
